export default {
  loading: '…',
  lang: {
    en: 'English',
    de: 'Deutsch',
    ru: 'Русский',
    fr: 'Français'
  },
  nav: {
    tools: 'Outils',
    connect: 'Connexion',
    discord: 'Discord',
    signIn: 'Connexion Steam',
    signOut: 'Déconnexion'
  },
  app: {
    runTime: 'Durée {time}',
    titleBreeder: 'rosi.wtf | Breeder',
    titleProgress: '{pct}% | GEN.{gen}'
  },
  logo: {
    plantTooltip:
      'Choisis un type de plante pour suivre ce que tu croises. Le choix <strong>n’affecte pas</strong> le résultat du calcul.'
  },
  sim: {
    eyebrow: 'rosi.wtf | Breeder',
    title: 'Planificateur de croisement',
    lead:
      'Colle une ligne de six lettres par plante. Si le navigateur l’autorise, capture la fenêtre du jeu et lis les gènes en OCR. Rien à installer.',
    calculate: 'Calculer',
    stop: 'Arrêter',
    skip: 'Passer',
    skipTooltip: 'Passer tôt à la génération suivante (plus rapide, certains chemins peuvent manquer).',
    emptyTitle: 'Aucun croisement viable avec cette liste',
    emptyBody:
      'Ajoute des plantes ou ajuste les scores dans les réglages. Des gènes sources plus forts donnent souvent de meilleurs chemins.',
    browserGen2:
      'Le jeune plant vient de la <strong>2e</strong> génération. Croise d’abord les jeunes plants nécessaires. Clique sur les plants <span class="simulator_highlight-guide">surlignés</span> pour voir comment les obtenir.',
    browserGen3:
      'Le jeune plant vient de la <strong>3e</strong> génération. Croise d’abord les jeunes plants nécessaires. Clique sur les plants <span class="simulator_highlight-guide">surlignés</span> pour voir comment les obtenir.',
    browserGeoBefore: 'Place les plantes avec un « E » près de l’',
    browserGeoAfter:
      ' dans les emplacements les plus à l’est de la jardinière, et celles avec un « W » à l’ouest pour influencer le croisement.'
  },
  gene: {
    current: 'Actuel',
    saved: 'Enregistrés',
    copied: 'Copié !',
    copyShare: 'Copier le lien',
    save: 'Enregistrer',
    geneSequences: 'Séquences de gènes',
    geneHint: 'Une plante par ligne : six lettres G, H, Y, W ou X.'
  },
  results: {
    labelG: 'Nb. de G',
    labelY: 'Nb. de Y',
    labelH: 'Nb. de H',
    geneN: 'Gène {n}',
    ariaIncG: 'Augmenter le nombre de G',
    ariaDecG: 'Diminuer le nombre de G',
    ariaIncY: 'Augmenter le nombre de Y',
    ariaDecY: 'Diminuer le nombre de Y',
    ariaIncH: 'Augmenter le nombre de H',
    ariaDecH: 'Diminuer le nombre de H',
    conflict: 'Tes filtres se contredisent : {detail}',
    alreadyOwned: 'Tu as déjà ce clone en #{n} dans ta liste',
    noResults: 'Aucun résultat avec ces filtres !',
    clickCard: 'Clique une carte pour les détails sur les générations et le croisement !',
    pressHold: 'Maintiens une carte pour voir les variantes.',
    showing: '{shown} sur {total} résultats. Resserre les filtres si la liste est longue.',
    ruleMinZero: 'Le minimum est zéro..',
    ruleMaxSix: 'Pas plus de six...',
    ruleWhole: 'Doit être un entier...'
  },
  map: {
    highlightedTitle: 'Résultat surligné',
    clearHighlight: 'Effacer le surlignage',
    tipGeoBefore: 'Place les plantes avec un « E » près de l’',
    tipGeoAfter:
      ' dans les emplacements les plus à l’est de la jardinière, et celles avec un « W » à l’ouest pour influencer le croisement.',
    learnMore: 'en savoir plus',
    tipGen2:
      'Le jeune plant vient de la <strong>2e</strong> génération. Il faut d’abord obtenir les jeunes plants requis. Clique sur les plants <span class="highlighted-map_highlight-guide">surlignés</span> pour voir comment les croiser.',
    tipGen3:
      'Le jeune plant vient de la <strong>3e</strong> génération. Il faut d’abord obtenir les jeunes plants requis. Clique sur les plants <span class="highlighted-map_highlight-guide">surlignés</span> pour voir comment les croiser.',
    numberHelp: '<strong>#NUMBER</strong> indique la position du jeune plant dans ta liste de gènes.'
  },
  browser: {
    helperVariants: 'Ici tu vois les différentes façons de croiser le même jeune plant.',
    optionBest: 'Meilleure option',
    optionAlt: 'Option alternative {n}'
  },
  previous: {
    empty: 'Tu n’as aucun ensemble de gènes enregistré.',
    genesCount: 'Plantes : {n}'
  },
  about: {
    trigger: 'À propos',
    title: 'À propos',
    fork:
      '<strong>rosi.wtf | Breeder</strong> est un fork de l’ancienne app web <strong>rustbreeder.com</strong>, retravaillée pour <a href="https://rosi.wtf" target="_blank" rel="noopener noreferrer">rosi.wtf</a>. La logique génétique et une grande partie du flux viennent de là (<a href="https://github.com/wojciechSlodziak/rust-breeder" target="_blank" rel="noopener noreferrer">code sur GitHub</a>).',
    fromOriginal: 'De l’auteur d’origine :',
    hi: 'Salut, j’espère que l’app te plaît :).',
    because: 'Je l’ai faite parce que croiser chaque wipe sans outil, c’était épuisant.',
    feedback:
      'Retours ou aide : rejoins mon <a href="https://discord.gg/Va5475pqFw" target="_blank" rel="noopener noreferrer">serveur Discord</a>.',
    donate:
      'Pour soutenir le travail et les frais, tu peux <a href="https://donorbox.org/rust-crossbreeding-optimizer?default_interval=o" target="_blank" rel="noopener noreferrer">faire un don</a>.',
    fine: 'Rust Breeder n’est pas affilié à Facepunch.',
    close: 'Fermer'
  },
  options: {
    title: 'Réglages',
    reset: 'Réinitialiser',
    tabCross: 'Croisement',
    tabUi: 'Interface et sons',
    performance: 'Performance',
    workers: 'Nombre de workers',
    workersHint: '~65 % des cœurs équilibre vitesse et chauffe. Plus pour la vitesse, moins pour la charge.',
    breeding: 'Élevage',
    saplingsRange: 'Plage de jeunes plants',
    saplingsRangeHint: '2–5 est un bon compromis efficacité / vitesse.',
    generations: 'Générations',
    saplingsNextGen: 'Jeunes plants pour la génération suivante',
    saplingsNextGenHint: 'Les meilleurs résultats de la génération actuelle alimentent le calcul suivant.',
    withRepetitions: 'Vérifier les combinaisons avec répétitions',
    withRepetitionsHint: 'Inclut les cas où une plante est utilisée plusieurs fois. Un peu plus lent.',
    geneScores: 'Scores des gènes',
    advanced: 'Avancé',
    manualMinScore: 'Score minimum suivi manuel',
    manualMinScoreHint: 'Des valeurs plus basses utilisent plus de mémoire.',
    minimumTrackedScore: 'Score minimum suivi',
    general: 'Général',
    soundsOn: 'Sons : activés',
    soundsOff: 'Sons : désactivés',
    autoSaveOn: 'Sauvegarde auto des gènes : oui',
    autoSaveOff: 'Sauvegarde auto des gènes : non',
    autoSaveHint: 'Désactivé : bouton de sauvegarde manuelle pour tes ensembles.',
    scanner: 'Scanner',
    skipGuideYes: 'Ignorer le guide de scan : oui',
    skipGuideNo: 'Ignorer le guide de scan : non',
    calibrationHeader: 'Alignement de capture',
    calibrationLead: 'Ajuste si les lettres ne correspondent pas à ta résolution ou à l’échelle UI de Rust.',
    horizontalNudge: 'Décalage horizontal',
    horizontalHint: 'Déplace les bandes de capture gauche/droite.',
    verticalNudge: 'Décalage vertical',
    verticalHint: 'Déplace les bandes haut/bas.',
    geneBoxScale: 'Échelle de la boîte de gène',
    geneBoxHint: '1,0 = défaut.',
    resetAlignment: 'Réinitialiser l’alignement',
    close: 'Fermer',
    set: 'Appliquer',
    setTooltip: 'Pour cette session seulement.',
    save: 'Enregistrer',
    saveTooltip: 'Appliquer et mémoriser dans le navigateur.',
    ariaInc: 'Augmenter',
    ariaDec: 'Diminuer',
    genTickOne: 'un',
    genTickTwo: 'deux',
    genTickThree: 'trois',
    geneScoreRule: 'Nombre entre -1 et 1.',
    saplingsAddedRule: 'Doit être un entier positif.',
    minTrackedRule: 'Plage acceptable : -6 à 6.'
  },
  scan: {
    scanRust: 'Scanner Rust',
    stopScanning: 'Arrêter le scan',
    initializing: 'Initialisation…',
    dialogTitle: 'Comment scanner Rust pour les jeunes plants ?',
    displayPreview: 'Aperçu écran',
    close: 'Fermer',
    scan: 'Scanner',
    li1:
      'De préférence <strong>Chrome</strong>, <strong>Edge</strong> ou <strong>Firefox</strong>. Les autres navigateurs peuvent mal fonctionner.',
    li2:
      'Vérifie que <strong>USER INTERFACE SCALE</strong> est à <strong>1,0</strong> dans Rust. Le curseur peut afficher 1,0 alors que la valeur est 0,97. La commande <strong>graphics.uiscale</strong> dans la console Rust donne la valeur réelle.',
    li3:
      'Joue en <strong>16:9</strong> (1600×900, 1080p, 1440p ou 4K) et en mode <strong>sans bordure</strong>. Sinon : fenêtré avec un ratio 16:9.',
    li4: 'Clique <strong>SCAN</strong> et choisis la fenêtre Rust.',
    li5a: 'Après le début du scan, affiche les gènes à l’écran :',
    li5b1: 'en cliquant un jeune plant dans l’inventaire ou le stockage,',
    li5b2: 'ou en regardant un jeune plant planté.',
    li5c: 'Environ une seconde par jeune plant.',
    li6: 'Bon jeu ! Si ça bloque, dis-le sur Discord. L’<strong>aperçu écran</strong> aide à voir ce qui ne va pas.'
  },
  mapCard: {
    score: 'Score :',
    chance: 'Chance :',
    centerLabel: 'Jeune plant central :',
    centerAnyExtra: 'n’importe quelle plante supplémentaire du même type',
    tooltipCenter1:
      'Jeune plant qui prend les gènes des plants environnants pendant la phase de croisement. Plantez-le au centre et laissez-le pousser seul jusqu’à ~50 % de la phase <strong>Jeune plant</strong>, puis placez les autres autour.',
    tooltipCenter2:
      'C’est toujours une plante <strong>supplémentaire</strong> : si l’app montre <strong>cinq</strong> plants autour, il faut <strong>six</strong> plantes au total.',
    tooltipCenter3Exact:
      'Il faut planter exactement la plante indiquée, sinon le croisement ne fonctionnera pas comme prévu.',
    tooltipCenter4Genes: 'Les gènes n’importent pas. Plus de G accélère la croissance.',
    tooltipCenter5SameType:
      '« Même type » : baies jaunes → le centre doit être une <strong>baie jaune</strong> ; pommes de terre → une <strong>pomme de terre</strong>.',
    surroundingLabel: 'Jeunes plants environnants :',
    tooltipSurrounding1: 'Plants autour du centre avant la phase de <strong>croisement</strong>. Tous du même type.',
    tooltipSurrounding2East: 'Place les plants selon les repères EST/OUEST autour du centre.',
    tooltipSurrounding2NoEast: 'Si le centre est au milieu de la jardinière, la position des autres importe peu.',
    tooltipSurrounding3:
      'Le centre atteint horizontal, vertical et diagonal en phase de croisement. Tu peux utiliser les huit cases restantes.'
  }
};
